export default function currency(amount, options = {}) {
    var formated = Config.currency.structure.replace('x', addThousandSeparator(parseFloat(amount).toFixed( Config.currency.precision)));

    if (!options.noSymbol && !(Config.mode == 'demo' && Config.hide_currency_symbol)) {
        formated = formated.replace('@',  Config.currency.symbol);
    } else {
        formated = formated.replace('@',  '');
    }

    if (Config.currency.custom_separator)
    {
        formated = formated.toString().replace('.', Config.currency.custom_separator);
    }

    return formated;
}

function addThousandSeparator(nStr)
{
    if(Config.currency.separator.length == 0)
    {
        return nStr;
    }

    nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';

    var rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1))
    {
        x1 = x1.replace(rgx, '$1' +  Config.currency.separator + '$2');
    }

    return x1 + x2;
}